import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28916aa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contract-market-upload" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card__title" }, "基本信息", -1))
const _hoisted_4 = { class: "card__grid" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card__title" }, "合同文件", -1))
const _hoisted_7 = { class: "upload-area" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload-area__primary" }, " 点击选择文件 或 拖拽合同扫描件到这里 ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload-area__hint" }, " 支持 .pdf / .jpg / .png，单文件不超过 10 MB ", -1))
const _hoisted_10 = { class: "affix-box" }

import { computed, reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseSelect,
  BaseUpload,
  BaseUploadRef,
  BaseButton,
  BaseIcon,
  XrkMessage
} from 'xrk-components';
import { Upload } from '@element-plus/icons-vue';

import appStore from '@/store';
import { uploadApi } from '@/common/data-source/common/apis';
import {
  getBoundIndustryList,
  uploadMarketServiceContract
} from '../data-source/apis';

import { BaseDatepickerLongterm } from '@/components/base/base-datepicker-longterm/index';


export default /*#__PURE__*/_defineComponent({
  __name: 'contract-market-upload',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const userStore = appStore.useUserStoreSetup;
const entpName = computed(() => userStore.info.entpName || '');

const { parentPath } = (route.meta as any) || {};
const tabQuery = (route.query.tab as string) || '';

const formRef = ref();
const uploadRef = ref<BaseUploadRef>(null);

const formData = reactive<{
  firstPartyId: number | null;
  contractName: string;
  validity: string;
  remarks: string;
  fileList: any[];
  contractRenderUrl: string;
  urlFileName: string;
}>({
  firstPartyId: null,
  contractName: '',
  validity: '',
  remarks: '',
  fileList: [],
  contractRenderUrl: '',
  urlFileName: ''
});

const rules = {
  firstPartyId: [
    { required: true, message: '请选择关联工业', trigger: 'change' }
  ],
  contractName: [
    { required: true, message: '请输入合同名称', trigger: 'blur' },
    { max: 50, message: '合同名称最多 50 字', trigger: 'blur' }
  ],
  validity: [
    { required: true, message: '请选择线下签署日期', trigger: 'change' }
  ],
  remarks: [{ max: 200, message: '备注最多 200 字', trigger: 'blur' }],
  contractRenderUrl: [
    { required: true, message: '请上传合同扫描件', trigger: 'change' }
  ]
};

const industryRemote = async entpName => {
  const resp = await getBoundIndustryList({
    type: 2, // 你写死 2-合同管理     类型 1 合同模板管理   2合同管理
    entpName,
    participantValue: 1, // 查询工业-1  查询服务商-2
    contractType: 3, // 合同类型 3-市场服务
    taxPattern: 0, // 交易结构 不用传
    source: 2, // 写死2  来源 ： 来源  1-模板过来的， 2-合同过来的
    pageNum: 1, //必传
    pageSize: 80 // 必传
  });
  return resp;
};

const handleValidityChange = () => {
  formRef.value.validateField('validity');
};

const uploading = ref(false);
const httpRequest = async ({ file }) => {
  uploading.value = true;
  return uploadApi({ file }).then(
    res => {
      formData.urlFileName = res.data.fileName;
      uploading.value = false;
      return res;
    },
    err => {
      uploading.value = false;
      return Promise.reject(err);
    }
  );
};

const onUploadError = (info: { msg: string }) => {
  XrkMessage.error(info.msg);
};

const goBackToList = () => {
  // 回来源页：parentPath + ?tab=<MARKET tab id>
  router.push({
    path: parentPath || '/main/asp/contract-mgmt/list',
    query: tabQuery ? { tab: tabQuery } : {}
  });
};

const onCancel = () => goBackToList();

const onSubmit = async () => {
  // 同步上传地址到 formData.contractRenderUrl 给规则校验
  if (formData.fileList?.length) {
    formData.contractRenderUrl = formData.fileList[0]?.url || '';
  } else {
    formData.contractRenderUrl = '';
  }

  try {
    await formRef.value.validate();
  } catch {
    XrkMessage.error('请补全标 * 的必填项');
    return;
  }

  await uploadMarketServiceContract({
    firstPartyId: formData.firstPartyId, // 签署方（关联工业）
    contractName: formData.contractName, // 合同名称
    validityStart: formData.validity?.[0], // 签署日期起
    validityEnd: formData.validity?.[1], // 签署日期止
    remarks: formData.remarks, // 备注
    contractRenderUrl: formData.contractRenderUrl, //上传文件
    urlFileName: formData.urlFileName, //上传文件
    type: 3
  });
  XrkMessage.success('提交成功');
  goBackToList();
};

return (_ctx: any,_cache: any) => {
  const _directive_xrk_loading = _resolveDirective("xrk-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseForm), {
      ref_key: "formRef",
      ref: formRef,
      model: formData,
      rules: rules,
      "label-position": "top",
      class: "contract-market-upload__form",
      "scroll-to-error": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(BaseFormItem), {
              label: "关联工业",
              prop: "firstPartyId",
              required: "",
              class: "card__cell"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseSelect), {
                  placeholder: "请选择关联工业（平台预绑定范围内）",
                  labelKey: "name",
                  valueKey: "id",
                  init: "",
                  clearable: "",
                  filterUseRemote: "",
                  modelValue: formData.firstPartyId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.firstPartyId) = $event)),
                  remoteMethod: industryRemote
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "合同名称",
              prop: "contractName",
              required: "",
              class: "card__cell"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  modelValue: formData.contractName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.contractName) = $event)),
                  maxlength: "50",
                  "show-word-limit": "",
                  placeholder: "请输入合同名称（最多 50 字）",
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "线下签署日期",
              prop: "validity",
              required: "",
              class: "card__cell"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseDatepickerLongterm), {
                  style: {"width":"100%","margin-top":"1px"},
                  startPlaceholder: "有效期始",
                  endPlaceholder: "有效期止",
                  value: formData.validity,
                  "onUpdate:value": [
                    _cache[2] || (_cache[2] = ($event: any) => ((formData.validity) = $event)),
                    handleValidityChange
                  ]
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "服务商（乙方）",
              prop: "",
              class: "card__cell"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  "model-value": entpName.value,
                  disabled: "",
                  style: {"width":"100%"}
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "备注 (选填)",
              prop: "remarks",
              class: "card__cell card__cell--full"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  modelValue: formData.remarks,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.remarks) = $event)),
                  type: "textarea",
                  rows: 4,
                  maxlength: "200",
                  "show-word-limit": "",
                  placeholder: "可填写合同的补充说明，最多 200 字",
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_unref(BaseFormItem), {
            prop: "contractRenderUrl",
            required: ""
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_unref(BaseUpload), {
                ref_key: "uploadRef",
                ref: uploadRef,
                fileList: formData.fileList,
                "onUpdate:fileList": _cache[4] || (_cache[4] = ($event: any) => ((formData.fileList) = $event)),
                "auto-upload": true,
                "http-request": httpRequest,
                accept: ['.pdf', '.jpg', '.png'],
                limit: 1,
                limitSize: 10,
                onError: onUploadError,
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_unref(BaseIcon), {
                      size: "48",
                      color: "#c1c7cd"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Upload))
                      ]),
                      _: 1
                    }),
                    _hoisted_8,
                    _hoisted_9
                  ])
                ]),
                _: 1
              }, 8, ["fileList"])), [
                [_directive_xrk_loading, uploading.value]
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), {
        style: {"margin-left":"12px"},
        type: "primary",
        click: onSubmit
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 提交 ")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})